// extracted by mini-css-extract-plugin
export default {"overlay":"LoginModal_overlay__gU68q","label":"LoginModal_label__Dkq-d","error":"LoginModal_error__ECVn9","submit":"LoginModal_submit__WJJn0"};